export default class buttonForm {
  constructor() {
    // Form
    this.forms = $('.js-button_form');
    this.selectElements = $('.js-button_form-select');

    this.selectElements.on('change', (event) => {
      event.preventDefault();
      this.toggleButton($(event.currentTarget).parents('form'), $(event.currentTarget).val());
    });
  }

  toggleButton($form, value) {
    const enabled = value !== '';
    const button = $form.find('.js-button_form-submit');
    button.toggleClass('is-hidden', !value);
    button.prop('href', value);
  }
}
